<template>
  <div class="productStatistics">

    <div class="queryForm">
      <a-row type="flex" style="width: 100%;">
        <a-col :sm="24" :md="24" :lg="5" :xl="7"></a-col>
        <a-col :sm="24" :md="24" :lg="14" :xl="10">
          <div class="search-keyword">
            <a-input placeholder="输入关键字搜索" v-model="blurry" style="min-width:250px; width: 67%;margin: 0 20px;"></a-input>
            <a-button type="primary" icon="search" @click="blurrySearch">搜索</a-button>
          </div>
        </a-col>
        <a-col :sm="24" :md="24" :lg="5" :xl="7"></a-col>
      </a-row>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :dataSource="dataTable"
        :pagination="pagination"
        @change="pagChange"
        :rowKey="(record,index) => index"
        :loading="loading"
      >
      <template slot="info" slot-scope="record">
        <p>{{record.certificateCount}}</p>
        <p>{{record.product}}/{{record.modelSpecification}}</p>
      </template>
      <template v-for="(item,index) in newData">
        <div :key="index" :slot="item.code" slot-scope="record">
          <p>{{record.certificateCount}}</p>
        </div>
      </template>
      </a-table>
    </div>

  </div>
</template>
<script>
import {productStatistic,presentationCategory} from '@/api/user'
const align = 'center'

export default {
  data() {
    return {
      columns:[
        {
          title: "产品信息(名称/型号)",
          scopedSlots: { customRender: 'info' },  //modelSpecification
          align,
          width:400
        },
        {
          title: "证书数量",
          dataIndex: "certificateCount",
          align
        },

      ],
      blurry:'',
      loading:false,
      dataTable:[
        {
          id:'1',product:'12',product1:'12',product2:'12',product3:'12',product4:'12',product5:'12',product6:'12',
        }
      ],
      pagination: {
        showSizeChanger:true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChange:(current, pageSize) => {
          this.pageSize = pageSize
        }
      },
      newData:[]
    }
  },
  
  created() {
    this.gettableData()
    this.getPresentationCategory()
    
  },
  beforeMount() {
  },
  mounted() {
    
  },
  methods: {
    getPresentationCategory(){
      let params = {
        parentCode:0
      }
      presentationCategory(params).then(res => {
        this.newData = res.content
        // this.newData.map(item => {
        // })
        this.newData.map(item=>{
          let obj = {
            title:item.name,
            scopedSlots:{customRender:item.code},
            align:'center'
          }
          this.columns.push(obj)
        })
      }).catch(error => {
        console.log(error)
      })
      
    },
    async gettableData(){
      const params = {
        page:this.pagination.current -1,
        size:this.pagination.pageSize
      }
      try{
        let data = await productStatistic(params)
        this.dataTable = data.content
      } catch (error){
        console.log(error)
      }
    },
    blurrySearch(){

    },
    pagChange(pagination,filters,sorter){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
  },
}
</script>
<style lang="less" scoped>
.productStatistics {
  min-height: 100%;
  background-color: #fff;
  padding: 15px;
  .queryForm{
    min-width: 600px;
    margin-bottom: 40px;
  }
  .table{
     /deep/.ant-table-expanded-row {
      td {
        padding: 5px 0 !important;
      }
      p {
        padding: 5px 0;
      }
    }
  }
}
</style>